import React from 'react';

import {useAcceptance} from 'app/acceptance/api';
import {isUserAcceptancePending} from 'app/acceptance/utils';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectAcceptURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import type {
  DocumentContentType,
  GenericAcceptableDocument,
} from 'app/acceptance/types';
import type {WithRouterProps} from 'react-router';

type Props<T> = {
  document: T;
  location: WithRouterProps['location'];
  forceTooltipShow?: boolean;
  contentType: DocumentContentType;
  onClick?: (ev: React.SyntheticEvent<unknown>) => void;
};

export const AcceptanceSidebarItem = <T extends GenericAcceptableDocument>({
  document,
  location,
  contentType,
  forceTooltipShow,
  onClick,
}: Props<T>) => {
  const acceptance = useAcceptance({
    object_pk: document.id,
    content_type: contentType,
  }).data?.results?.[0];

  const userAcceptanceIsPending = isUserAcceptancePending(document, acceptance);

  return (
    <SidebarItem
      title={
        userAcceptanceIsPending
          ? gt('Your approval was requested')
          : gt('Approval Requested')
      }
      disabled={acceptance == null}
      disabledTooltipText={gt(
        'No approval requests found for this %s',
        getContentType(contentType).name
      )}
      icon="far fa-thumbs-up"
      badge={
        userAcceptanceIsPending ? (
          <span className="text-danger font-weight-bold">!</span>
        ) : undefined
      }
      link={
        acceptance != null
          ? getObjectAcceptURL(document, acceptance.object_id, location.search)
          : ''
      }
      forceTooltipShow={forceTooltipShow}
      onClick={onClick}
    />
  );
};
